// extracted by mini-css-extract-plugin
module.exports = {"link_animated":"TextLinks_link_animated__3-jjd","link_color":"TextLinks_link_color__2QL6i","link":"TextLinks_link__2sqiw","link_text":"TextLinks_link_text__1P2UE"};